// extracted by mini-css-extract-plugin
export var headerCell = "_4g-1";
export var loadingSpinnerContainer = "_4g-4";
export var rowWrapper = "_4g-3";
export var standaloneTable = "_4g-5";
export var table = "_4g-0";
export var white = "_4g-2";